import { Moment } from 'moment-timezone';

export interface UserNotification {
    id: number | undefined;
    uuid?: string;
    marketplaceId: number;
    receiptId?: number;
    appointmentId?: number;
    bookingId?: number;
    clientId?: number;
    petId?: number;
    enrollmentId?: number;
    vaccineApprovalId?: number;
    waitlistId?: number;
    bookingStatus?: number;
    subject: string | HTMLBodyElement;
    body: string | HTMLBodyElement;
    type: UserNotificationType;
    subtype?: UserNotificationSubtype;
    source?: string;
    status?: string;
    sentAt?: Moment;
    readAt?: Moment;
    updatedAt?: Moment;
    openedAt?: Moment;
    createdAt: Moment;
}

export enum UserNotificationType {
    BOOKING = 'Booking',
    INTAKE_FORM = 'IntakeForm',
    BOOKING_REQUEST = 'BookingRequest',
    VACCINE_EXPIRED = 'VaccineExpired',
    VACCINE_APPROVAL = 'VaccineApproval',
    //test for deployment
    REVIEW = 'Review',
    MEMBERSHIP_PAYMENT_ISSUE = 'MembershipPaymentIssue',
    WAITLIST_REQUEST = 'WaitlistRequest',
    NONE = 'None'
}

export enum UserNotificationSubtype {
    CONFIRMED = 'CONFIRMED',
    CANCELED = 'CANCELED'
}

export enum RecipientType {
    CUSTOMER = 'Customer',
    STAFF = 'Staff'
}
